import { render, staticRenderFns } from "./Mesas.vue?vue&type=template&id=3fbc883e&scoped=true&"
import script from "./Mesas.vue?vue&type=script&lang=js&"
export * from "./Mesas.vue?vue&type=script&lang=js&"
import style0 from "./Mesas.vue?vue&type=style&index=0&id=3fbc883e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc883e",
  null
  
)

export default component.exports